// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15CJc","footer":"styles_footer__2f5Ay"};